'use client';

import { FC, useMemo } from 'react';
import classNames from 'classnames';
import CountUp from 'react-countup';
import narilaZEHNVONZEHN from '@/assets/emotes/narilaZEHNVONZEHN.png';
import classes from './NariPoints.module.css';

interface NariPointsProps {
    amount: number;
    withIcon?: boolean;
    fixed?: boolean;
    formattingFn?: (value: number) => string;
}

export const NariPoints: FC<NariPointsProps> = ({ amount, withIcon = false, fixed = false, formattingFn }) => {
    const colorClass = useMemo(() => {
        if (amount >= 100000) {
            return classes['nari-points-100000'];
        }
        if (amount >= 10000) {
            return classes['nari-points-10000'];
        }
        if (amount >= 5000) {
            return classes['nari-points-5000'];
        }
        if (amount >= 1000) {
            return classes['nari-points-1000'];
        }
        if (amount >= 100) {
            return classes['nari-points-100'];
        }
        return classes['nari-points-1'];
    }, [amount]);

    return (
        <>
            <CountUp preserveValue formattingFn={formattingFn} className={classNames(classes['nari-points'], colorClass)} start={fixed ? amount : 0} end={amount} duration={0.4} separator="." />
            {withIcon && <img src={narilaZEHNVONZEHN.src} alt="Nari-Punkte" className={classes['nari-points-icon']} />}
        </>
    );
};
